var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container container-small" }, [
      _c("div", { staticClass: "bottom-menu simple" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("ul", { staticClass: "list-unstyled list-inline text-small" }, [
              _c("li", { staticClass: "list-inline-item" }, [
                _c("a", { attrs: { href: "#" } }, [_vm._v("Lorem")]),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-inline-item" }, [
                _c("a", { attrs: { href: "#" } }, [_vm._v("Ipsum")]),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-inline-item" }, [
                _c("a", { attrs: { href: "#" } }, [_vm._v("Lorem")]),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-inline-item" }, [
                _c("a", { attrs: { href: "#" } }, [_vm._v("Ipsum")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-auto ms-auto" }, [
            _c("div", { staticClass: "social-links" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col text-end" }, [
                  _c("ul", { staticClass: "list-inline" }, [
                    _c("li", { staticClass: "list-inline-item" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _c("i", { staticClass: "bi bi-facebook" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "list-inline-item" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _c("i", { staticClass: "bi bi-twitter" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "list-inline-item" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _c("i", { staticClass: "bi bi-linkedin" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "list-inline-item" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _c("i", { staticClass: "bi bi-instagram" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "list-inline-item" }, [
                      _c("a", { attrs: { href: "#" } }, [
                        _c("i", { staticClass: "bi bi-youtube" }),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "coop" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col text-center" }, [
            _c("ul", { staticClass: "list-inline" }, [
              _c("li", { staticClass: "list-inline-item" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                      title: "Biuletyn Informacji Publicznej",
                    },
                  },
                  [
                    _c("img", {
                      attrs: { src: "/images/logos-bip.png", alt: "" },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-inline-item" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                      title:
                        "Infrastruktura i Środowisko - Narodowa Strategia Spójności",
                    },
                  },
                  [
                    _c("img", {
                      attrs: { src: "/images/logos-nss.png", alt: "" },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-inline-item" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                      title: "Unia Europejska - Funduszu Spójności",
                    },
                  },
                  [
                    _c("img", {
                      attrs: { src: "/images/logos-ue.png", alt: "" },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }